module.exports = __webpack_public_path__ + "img/markiplier.c8483e07.png";